import { render } from "./LicenseDetail.vue?vue&type=template&id=cd2a731c&scoped=true"
import script from "./LicenseDetail.vue?vue&type=script&lang=js"
export * from "./LicenseDetail.vue?vue&type=script&lang=js"

import "./LicenseDetail.vue?vue&type=style&index=0&id=cd2a731c&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd2a731c"]])

export default __exports__